// @Version: 1.0.0
import { Injectable } from "@angular/core";
import { Location} from "@angular/common";
import { ROUTESURL } from "src/app/app-routing.model";
import { Router } from "@angular/router";
import {SESSIONINFOERROR} from "./error-openapi.model";


@Injectable({
   providedIn: 'root'
})

export class ErrorOpenApiService {

   public URL = URL;

   constructor (public router: Router, public location: Location) {}

   public routingCode (error: string | Error): boolean {
      let code;
      let isError = false;
      let isLogin = false; 

      if (typeof error != 'string' && error.message && error.message.indexOf("Error: Invocation canceled due to the underlying connection being closed.") > -1) {
         code = 907;
         isError = true;
      } else if (typeof error == 'string' && (error.indexOf("UUID fehlt") != -1 || error== '910' )) { //VPublic Key kann nicht eingelesen werden
         code = 910;
         isError = true;
      }
      else if (typeof error == 'string' && error.indexOf("Timeout beim Warten auf Verbindungsbestätigung") != -1) { //Verbindung zum Kommunikationsserver kann nicht hergestellt werden
         code = 901;
         isError = true;
      } else if (typeof error == 'string' &&  error.indexOf("Backend ist dem Server nicht bekannt") != -1) { //Verbindung zum Backend kann nicht hergestellt werden
         code = 902;
         isError = true;
      } else if (typeof error == 'string' &&  error.indexOf("Backend-Error: connect_error in send:") != -1) { //Verbindung zum GDix kann nicht hergestellt werden
         //connect_error in send:
         if (typeof error == 'string' &&  error.indexOf("Fehler (12029)") != -1) {
            code = 903;
            isError = true;
         } 
         else if (typeof error == 'string' && error.indexOf("Fehler (12175)") != -1) { //Verbindung zum Endpunkt kann nicht hergestellt werden
            code = 908;
            isError = true;
         } 
         else if (typeof error == 'string' && error.indexOf("HTTP Status Code: 507") != -1) { //Verbindung zum Endpunkt kann nicht hergestellt werden
            code = 909;
            isError = true;
         } 
      } else if (typeof error == 'string' && error.indexOf("HTTP Status Code: 401") != -1) { //Verbindung zum Endpunkt kann nicht hergestellt werden
         code = 904;
         isError = false;
         isLogin = true; 
      } else if (typeof error == 'string' && error.indexOf("HTTP Status Code: 404") != -1) { //Verbindung zum Endpunkt kann hergestellt werden aber URL nicht vorhanden
         code = 905;
         isError = true;
      } else if(typeof error == 'string' && error.indexOf("Timeout beim Warten auf Antwort vom Backend") != -1) { //Backend antwortet nicht
         code = 906;
         isError = true;
      } else if(typeof error == 'string' && error.indexOf("HTTP Status Code: 500") != -1) { 
         code = 500;
         isError = true
      } else if(typeof error == 'string' && error.indexOf("911") != -1) {
         code = 911
         isError = true
      } else if(typeof error == 'string' && error.indexOf("912") != -1) {
         code = 912
         isError = true
      } else if(typeof error == 'string' && error.indexOf("913") != -1) {
         code = 913
         isError = true
      }

      if (typeof error == 'string' && error.indexOf('Backend-Error:') > -1 && !isLogin) {
         isError = true;
      }

      if (isError)  {
         console.error(error)
         sessionStorage.setItem(SESSIONINFOERROR.ENTRYURL, this.location.path())
         this.router.navigate([ROUTESURL.MAINTENANCEWORK], {queryParams: { code: code}});
      } 

      return isError ? false : true;
   }
}